import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-constitution",
  "use": "icon-constitution-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-constitution\"><path d=\"M277.333 298.667v490.666h437.334v64H309.333a96 96 0 0 1-95.893-91.477l-.107-4.523V298.667h64zm472.79-127.787a64 64 0 0 1 64 64v451.243a64 64 0 0 1-64 64H319.787V234.88a64 64 0 0 1 64-64h366.336zm0 64H383.787v451.243h366.336V234.88zM640 298.667v64H448v-64h192z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol